<div class="reset-password container-fluid no-gutters">
  <div class="row">
    <div class="col-6 mr-auto ml-auto">
      <form class="form-group" [formGroup]="resetPasswordForm"
        (ngSubmit)="sendResetPasswordRequest()">

        <div class="form-group">
          <label for="emailAddress">{{"RESET-PASSWORD.RETYPE-EMAIL" | translate }}</label>
          <input type="email" name="emailAddress" id="emailAddress" class="form-control"
            formControlName="emailAddress">
        </div>

        <div class="form-group">
          <label for="password">{{ "RESET-PASSWORD.NEW-PASSWORD" | translate }}</label>
          <input type="password" name="password" id="password" class="form-control"
            formControlName="password">
        </div>

        <div class="form-group">
          <label for="retypePassword">{{ "RESET-PASSWORD.RETYPE-PASSWORD" | translate }}</label>
          <input type="password" name="retypePassword" id="retypePassword" class="form-control"
            formControlName="retypePassword">

          <span *ngIf="resetPasswordForm.errors?.noMatch">
            {{ "RESET-PASSWORD.ERRORS.RETYPE" | translate }}
          </span>
        </div>

        <div>
          <button type="submit" role="submit" class="btn btn-outline-secondary"
            [disabled]="!resetPasswordForm.valid">
            {{ "RESET-PASSWORD.UPDATE" | translate }}
          </button>
        </div>

        <div *ngIf="errorMessage">
          <span>{{ errorMessage | translate }}</span>
        </div>
      </form>
    </div>
  </div>
</div>

<app-footer></app-footer>
